import { BaseComponent } from '../../lib/BaseComponent.js';
import { api } from '../../lib/api.js';
import { authStyles } from './authStyles.js';

/**
 * Forgot Password Page - requests a reset link by email.
 */
export class ForgotPasswordPage extends BaseComponent {
  private isLoading = false;
  private sent = false;
  private errorMessage = '';
  private devResetUrl = '';

  protected render(): void {
    this.addStyles(this.getCommonStyles());
    this.addStyles(authStyles());

    const container = this.createElement('div', { className: 'auth-container' });
    const header = this.createElement('div', { className: 'auth-header' });
    const title = this.createElement('h1');
    title.appendChild(this.createElement('a', { href: '/' }, 'FireGuard'));
    header.appendChild(title);
    header.appendChild(this.createElement('p', { className: 'subtitle' }, 'Reset your password'));
    container.appendChild(header);

    const card = this.createElement('div', { className: 'auth-card' });
    card.appendChild(this.createElement('h2', {}, 'Forgot your password?'));

    if (this.sent) {
      card.appendChild(
        this.createElement(
          'div',
          { className: 'success-message' },
          'If an account exists for that email, a reset link is on its way. It works for 60 minutes. Check your spam folder if it does not arrive.'
        )
      );
      if (this.devResetUrl) {
        const dev = this.createElement('p', { className: 'hint' }, 'Development mode (email not configured): ');
        dev.appendChild(this.createElement('a', { href: this.devResetUrl }, 'open reset link'));
        card.appendChild(dev);
      }
    } else {
      card.appendChild(this.createElement('p', { className: 'help' }, 'Enter your work email and we will send you a link to choose a new password.'));
      if (this.errorMessage) {
        card.appendChild(this.createElement('div', { className: 'error-message' }, this.errorMessage));
      }
      const form = this.createElement('form', { className: 'auth-form' });
      form.addEventListener('submit', (e) => this.handleSubmit(e));
      const group = this.createElement('div', { className: 'form-group' });
      group.appendChild(this.createElement('label', { for: 'email' }, 'Email'));
      group.appendChild(this.createElement('input', { type: 'email', id: 'email', name: 'email', required: 'true', autocomplete: 'email', placeholder: 'you@company.com' }));
      form.appendChild(group);
      const btn = this.createElement('button', { type: 'submit', className: 'btn-primary' }, this.isLoading ? 'Sending…' : 'Send reset link');
      if (this.isLoading) btn.setAttribute('disabled', 'true');
      form.appendChild(btn);
      card.appendChild(form);
    }

    const footer = this.createElement('div', { className: 'auth-footer' });
    const p = this.createElement('p', {}, 'Remembered it? ');
    p.appendChild(this.createElement('a', { href: '/login' }, 'Sign in'));
    footer.appendChild(p);
    card.appendChild(footer);

    container.appendChild(card);
    this.shadow.appendChild(container);
  }

  private async handleSubmit(e: Event): Promise<void> {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const email = (new FormData(form).get('email') as string) || '';
    this.isLoading = true;
    this.errorMessage = '';
    this.rerender();
    try {
      const res = await api.forgotPassword(email);
      this.sent = true;
      this.devResetUrl = res.dev_reset_url || '';
    } catch (error) {
      this.errorMessage = (error as Error).message || 'Could not send reset link';
    } finally {
      this.isLoading = false;
      this.rerender();
    }
  }

  private rerender(): void {
    this.shadow.replaceChildren();
    this.render();
  }
}

customElements.define('forgot-password-page', ForgotPasswordPage);
